(function ($) {
  // Select all links with a hash (#) in the href
  $('a.smooth-scroll[href*="#"]').on('click', function(event) {
    // Ensure the link is pointing to a section on the current page
    if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {

      // Target element based on the link's hash
      var target = $(this.hash);
      target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');

      // If a target section exists, execute the smooth scroll
      if (target.length) {
        event.preventDefault(); // Stop the default instant jump

        $('html, body').animate({
          scrollTop: target.offset().top - 80
        }, 800, function() {
          // Optional: Update the browser URL hash when the animation finishes
          // window.location.hash = target.selector;
        });
      }
    }
  });
})(jQuery);